// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__37hIB","title":"AfterImages90_title__2sQPE","images":"AfterImages90_images__3g6lz"};